import { Zahlweise } from '@ps20/bff-models';
import { getZahlweiseFromText } from '@ps20-frontend/migrations';
import { StatePreV10, StateV10 } from './10_migrate_zahlungsweise.interface';

export const migrateZahlungsoptionen = (
  previousState: StatePreV10,
  newVersion: number,
): StateV10 => {
  return {
    ...previousState,
    version: newVersion,
    zahlungsweise: previousState.zahlungsweise
      ? getZahlweiseFromText(previousState.zahlungsweise)
      : Zahlweise.MONATLICH,
  };
};
